// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'
import store from './store'
Vue.use(Vuex)
import router from './router'

// 引入 babel-plyfill
import "babel-polyfill"
import 'font-awesome/css/font-awesome.min.css'
import VueHtml5Editor from 'vue-html5-editor'

import VueTouch from 'vue-touch'
Vue.use(VueTouch, { name: 'v-touch' })
VueTouch.config.swipe = {
  threshold: 50  //设置左右滑动的距离
}

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

Vue.use(VueAwesomeSwiper)

// router.beforeEach(() => {
//     // window.scrollTo(0,0)
// })

// var xhr = new XMLHttpRequest();
// //设置请求的类型及url
// //post请求一定要添加请求头才行不然会报错
//
// xhr.open('post', '/depression-api/Qiniu/obtainPictureUploadToken.json' );
// xhr.setRequestHeader("Content-type","application/x-www-form-urlencoded");
// //发送请求
// xhr.send('');
// xhr.onreadystatechange = function () {
//     console.log(xhr)
//     // 这步为判断服务器是否正确响应
//     if (xhr.readyState == 4 && xhr.status == 200) {
//         let data=JSON.parse(xhr.responseText)
//         // token=data.token
//         localStorage.setItem('token',data.token)
//     }
// };



Vue.config.productionTip = false;


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})

// console.log(Vue)




// WEBPACK FOOTER //
// ./src/main.js